export default "__VITE_ASSET__f0319ed1__"